<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <back-link :link="{ name: 'EvalEvaluations' }" text="в каталог оценок 360" margin="0 0 20px 0"></back-link>
    <page-heading :heading="evaluation.name">
      <span slot="help"></span>
      <div slot="right">
        <div class="el-row--flex">
          <el-popconfirm
            confirm-button-text='Да'
            cancel-button-text='нет'
            icon="el-icon-question"
            :title="$companyConfiguration.i18n.t('evaluation', evaluation.status + '_title', 'Уверены что хотите запустить следующий этап?')"
            @confirm="startEvaluation()"
          >
            <el-button
              slot="reference"
              type="primary"
              size="small"
            >
              {{ $companyConfiguration.i18n.t('evaluation', evaluation.status + '_button', 'Запустить следующий этап') }}
            </el-button>
          </el-popconfirm>
        </div>
      </div>
    </page-heading>
    <div>
      <el-tabs :value="tabsValue">
        <el-tab-pane label="Настройки оценки 360" name="evaluation_setting">
          <el-card>
            <evaluation-setting
              :isDisabledSetting="isDisabledSetting"
              :evaluation="evaluation"
              :loading="loading"
            ></evaluation-setting>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="users">
          <template #label>
            Настройки участников
            <span v-if="totalErrorCount" style="color: red">
              <i class="fas fa-exclamation-circle"></i>
            </span>
          </template>
          <el-card>
            <evaluation-members
              @refresh-evaluators="refreshEvaluators"
              :evaluation="evaluation" :isDisabledSetting="isDisabledSetting"
              @update-total-count="totalErrorCount = $event"
            ></evaluation-members>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="evaluation.status && evaluation.status !== 'created'" label="Оценивающие" name="evaluators">
          <el-card>
            <evaluation-evaluators-table ref="evaluatorsTable" :evaluation="evaluation"></evaluation-evaluators-table>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import EvaluationSetting from "@/modules/evaluation/components/evaluation/EvaluationSetting";
import EvaluationMembers from "@/modules/evaluation/components/evaluation/EvaluationMembers";
import EvaluationEvaluatorsTable from "@/modules/evaluation/components/evaluation/EvaluationEvaluatorsTable";
import BackLink from "@/components/BackLink.vue";

export default {
  name: 'eval-evaluation',
  components: {
    BackLink,
    EvaluationEvaluatorsTable,
    EvaluationSetting,
    EvaluationMembers,
    PageHeading,
  },
  data() {
    return {
      loading: false,
      tabsValue: 'evaluation_setting',
      isDisabledSetting: false,
      totalErrorCount: 0,
      evaluation: {
        type: Object,
        default: {},
      },
    }
  },
  mounted() {
    this.getEvaluation();
  },
  methods: {
    startEvaluation() {
      this.loading = true;
      this.$api.evaluation.evaluationNextStep({
        id: this.$route.params.id,
      })
        .then(data => {
          if (data.status === 'error') {
            this.$notify.error({
              title: 'Ошибка',
              message: data.message
            });
          } else {
            this.getEvaluation();
            this.isDisabledSetting = true;
            this.$notify.success({
              title: 'Успех',
              message: data.message
            });

            if (this.$refs.evaluatorsTable) {
              this.$refs.evaluatorsTable.loadEvaluationEvaluators();
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEvaluation() {
      this.loading = true;
      this.$api.evaluation.evaluationGet({
        id: this.$route.params.id,
      })
        .then(data => {
          this.evaluation = data.evaluation;
          this.isDisabledSetting = (this.evaluation.status !== 'created');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refreshEvaluators() {
      this.$refs.evaluatorsTable?.loadEvaluationEvaluators();
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>